import DeleteIcon from "@mui/icons-material/Delete";
import StoreIcon from "@mui/icons-material/Store";
import { Grid, Avatar, IconButton, Tooltip, Divider, Card } from "@mui/material";
import React, { useEffect, useState } from "react";

import { useBusinessContext } from "0.Mine/2.Context/businessContext";
import { Business } from "0.Mine/3.Interfaces/business";
import { SafeArgonBox, SafeArgonTypography, SafeArgonButton } from "0.Mine/4.Argon/ArgonComponents";

const AddOrRemoveBusinesses = () => {
  const { session } = useBusinessContext();
  const [businesses, setBusinesses] = useState<Business[]>([]);

  useEffect(() => {
    if (session) {
      setBusinesses(session.businesses || []);
    }
  }, [session]);

  const handleDeleteBusiness = (businessId: number) => {
    // Here you would implement the actual deletion logic
    console.log(`Delete business with ID: ${businessId}`);
    // For UI feedback, we'll update the local state
    setBusinesses((prev) => prev.filter((business) => business.id !== businessId));
  };

  return (
    <Card id="connected-businesses">
      <SafeArgonBox p={3}>
        <SafeArgonTypography variant="h6" fontWeight="medium" mb={2}>
          Connected Businesses
        </SafeArgonTypography>

        {/* Header row */}
        <Grid container spacing={2} alignItems="center" mb={1}>
          <Grid item xs={1}>
            <SafeArgonTypography variant="caption" color="text" fontWeight="bold">
              ID
            </SafeArgonTypography>
          </Grid>
          <Grid item xs={2}>
            <SafeArgonTypography variant="caption" color="text" fontWeight="bold">
              Logo
            </SafeArgonTypography>
          </Grid>
          <Grid item xs={8}>
            <SafeArgonTypography variant="caption" color="text" fontWeight="bold">
              Business Name
            </SafeArgonTypography>
          </Grid>
          <Grid item xs={1}>
            <SafeArgonTypography variant="caption" color="text" fontWeight="bold">
              Actions
            </SafeArgonTypography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 1 }} />

        {businesses.length > 0 ? (
          businesses.map((business) => (
            <React.Fragment key={business.id}>
              <Grid
                container
                spacing={2}
                alignItems="center"
                sx={{
                  py: 1.5,
                  "&:hover": {
                    bgcolor: "rgba(0,0,0,0.04)",
                    borderRadius: "8px",
                  },
                }}
              >
                <Grid item xs={1}>
                  <SafeArgonTypography variant="button" color="text">
                    #{business.id}
                  </SafeArgonTypography>
                </Grid>
                <Grid item xs={2}>
                  {business.logoUrl ? (
                    <Avatar
                      src={
                        typeof business.logoUrl === "string"
                          ? business.logoUrl
                          : URL.createObjectURL(business.logoUrl)
                      }
                      alt={`${business.name} logo`}
                      sx={{ width: 40, height: 40 }}
                    />
                  ) : (
                    <Avatar sx={{ width: 40, height: 40, bgcolor: "primary.main" }}>
                      <StoreIcon />
                    </Avatar>
                  )}
                </Grid>
                <Grid item xs={8}>
                  <SafeArgonTypography variant="button" color="dark" fontWeight="medium">
                    {business.name}
                  </SafeArgonTypography>
                </Grid>
                <Grid item xs={1} textAlign="center">
                  <Tooltip title="Remove Business">
                    <IconButton
                      color="error"
                      size="small"
                      onClick={() => handleDeleteBusiness(business.id)}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
              <Divider sx={{ my: 0.5 }} />
            </React.Fragment>
          ))
        ) : (
          <SafeArgonBox py={3} textAlign="center">
            <SafeArgonTypography variant="body2" color="text">
              No businesses connected to this account.
            </SafeArgonTypography>
          </SafeArgonBox>
        )}
      </SafeArgonBox>
    </Card>
  );
};

export default AddOrRemoveBusinesses;
